import { createReducer } from 'typesafe-actions';
import { ClubRegistrationState } from '../types';
import { updateClubRegistrationStatus, resendDoiConfirmationActions, ClubRegistrationActions } from './actions';

const ClubRegistrationReducer = createReducer<ClubRegistrationState, ClubRegistrationActions>({
    doi: {
        isFetching: false,
        didInvalidate: false,
    },
})
    .handleAction(updateClubRegistrationStatus, (state, action) => ({
        ...state,
        status: action.payload,
        didInvalidate: true,
    }))
    .handleAction(resendDoiConfirmationActions.request, state => ({
        ...state,
        doi: {
            ...state.doi,
            isFetching: true,
        },
    }))
    .handleAction(resendDoiConfirmationActions.success, (state, action) => ({
        ...state,
        doi: {
            isFetching: false,
            doiMessage: action.payload,
            doiError: null,
            didInvalidate: false,
        },
    }))
    .handleAction(resendDoiConfirmationActions.failure, (state, action) => ({
        ...state,
        doi: {
            isFetching: false,
            doiMessage: '',
            doiError: action.payload,
            didInvalidate: true,
        },
    }));

export default ClubRegistrationReducer;
